export const CUSTOM_EVENT_IDS = {
  ChangeUserBalance: 'change-user-balance',
  CasinoNavbarCLick: 'casino-navbar-click',
};
